import * as React from "react";
var t = function(n) {
  return n();
}, a = React.useInsertionEffect ? React.useInsertionEffect : false, c = a || t;
export {
  c as useInsertionEffectAlwaysWithSyncFallback
};
//# sourceMappingURL=emotion-use-insertion-effect-with-fallbacks.browser.esm.es.es.js.map
